import { CLASSNAME } from '~/assistant/utils/constants';
import { bem } from '~/common/classname';
import './styles.scss';

type Props = {
  target: HTMLElement;
  [key: string]: any;
};

class Title {
  props: Props;

  constructor(props: Props) {
    this.props = { ...props };
    this.render();
  }

  template() {
    const { logoImage, title } = this.props;
    return /*html*/ `
      <div class="${bem([CLASSNAME, 'title'])}">
        ${
          logoImage
            ? /*html*/ `
          <img alt="" src="${logoImage}" class="${bem([
                CLASSNAME,
                'title',
                'logo',
              ])}" />
        `
            : ''
        }
        <p class="${bem([
          CLASSNAME,
          'title',
          'text',
        ])}"><span>AI</span> ${title}</p>
      </div>
    `;
  }

  render() {
    const { target } = this.props;
    target.insertAdjacentHTML('beforeend', this.template());
  }
}

export default Title;
